import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { useEffect, useState } from 'react'
import { Icon } from '@iconify/react'
import Loader from 'react-loaders'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    setTimeout(() => {
      return setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['S', 'o', 'b', 'r', 'e', ' ', 'm', 'i', 'm']}
              idx={15}
            />
          </h1>
          <p>
            Olá! Sou um apaixonado desenvolvedor Front-end com três anos de
            sólida experiência na indústria. Minha jornada no mundo do
            desenvolvimento web tem sido marcada por um compromisso inabalável
            com a entrega de experiências digitais excepcionais.
          </p>
          <p>
            Estou sempre pronto para abraçar novos desafios e aprender novas
            tecnologias, mantendo-me atualizado com as últimas tendências do
            mundo da programação. Minha abordagem é centrada no usuário,
            priorizando a usabilidade e a elegância do design.
          </p>
          <p>
            Sou focado em aplicações{' '}
            <span className="enphasis">React</span>, e possuo uma experiência
            sólida com <span className="enphasis">NextJS</span>,{' '}
            <span className="enphasis">MaterialUI</span> e{' '}
            <span className="enphasis">TypeScript</span>.
          </p>
          <p>
            Se você busca um profissional comprometido, apaixonado e altamente
            competente para impulsionar seu projeto para o próximo nível, estou
            entusiasmado para contribuir com minha experiência e paixão pelo
            desenvolvimento Front-end.
          </p>
        </div>

        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <Icon icon="skill-icons:react-dark" />
            </div>
            <div className="face2">
              <Icon icon="skill-icons:typescript" />
            </div>
            <div className="face3">
              <Icon icon="skill-icons:javascript" />
            </div>
            <div className="face4">
              <Icon icon="skill-icons:materialui-dark" />
            </div>
            <div className="face5">
              <Icon icon="skill-icons:nextjs-dark" />
            </div>
            <div className="face6">
              <Icon icon="skill-icons:git" />
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
